(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/welcome-team-list.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/welcome-team-list.js');
'use strict';

const {
  Button
} = svs.ui;
const {
  Link
} = ReactRouterDOM;
const {
  GameList
} = svs.components.marketplace.gameList;
const {
  TeamListContainer
} = svs.components.marketplace.teamList;
const {
  WelcomeNewPlayer,
  WelcomeRetail
} = svs.marketplace.components.welcome;
const findPath = 'hitta-andelsspel';
const WelcomeTeamList = _ref => {
  let {
    linkTo,
    linkToFind,
    hasRetailers,
    hasTeams,
    history,
    isAuthenticated
  } = _ref;
  return React.createElement(React.Fragment, null, hasRetailers ? React.createElement("div", {
    className: "bg-red-100 marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "welcome-team-list-header f-bold f-900"
  }, "Dina butiker"), React.createElement("div", {
    className: "welcome-team-list retailer padding-top-1",
    "data-testid": "qa-mkp-retail-teamlist"
  }, React.createElement(TeamListContainer, {
    history: history,
    isHeaderInverted: true,
    isRetail: true,
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true
  }, team => React.createElement(GameList, {
    className: "game-list-welcome",
    fromTeamList: true,
    groupId: team.id,
    hasBottomBorder: true,
    isRetail: true,
    maxGamesToDisplay: 3,
    noFetch: true
  }))), React.createElement("div", {
    className: "welcome-team-list-button-container"
  }, React.createElement(Button, {
    block: true,
    className: "qa-find-team-button",
    inverted: true
  }, React.createElement(Link, {
    className: "qa-find-team-link",
    to: linkToFind
  }, "Hitta andelsspel"))))) : React.createElement(WelcomeRetail, {
    linkTo: findPath
  }), hasTeams ? React.createElement("div", {
    className: "bg-sport-100 marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "welcome-team-list-header f-bold f-900"
  }, "Dina lag"), React.createElement("div", {
    className: "welcome-team-list padding-top-1",
    "data-testid": "qa-mkp-customer-teamlist"
  }, React.createElement(TeamListContainer, {
    isHeaderInverted: true,
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true
  }, team => React.createElement(GameList, {
    className: "game-list-welcome",
    fromTeamList: true,
    groupId: team.id,
    hasBottomBorder: true,
    maxGamesToDisplay: 3,
    noFetch: true
  }))), React.createElement("div", {
    className: "welcome-team-list-button-container"
  }, React.createElement(Link, {
    className: "qa-create-team-link",
    to: linkTo
  }, React.createElement(Button, {
    block: true,
    className: "qa-create-team-open-button",
    inverted: true
  }, "Starta ett lag"))))) : React.createElement(WelcomeNewPlayer, {
    isAuthenticated: isAuthenticated,
    linkTo: linkTo
  }));
};
setGlobal('svs.marketplace.components.welcome.WelcomeTeamList', WelcomeTeamList);

 })(window);